import React from "react";
import Modal from "./Modal";

interface LoadingModalProps {}

const LoadingModal: React.FC<LoadingModalProps> = ({ children }) => {
  return (
    <Modal className="bg-light border-t-4 border-orange p-4 rounded-lg flex flex-col items-center w-84 text-text shadow-xl">
      {children}
    </Modal>
  );
};

export default LoadingModal;
